import FolderIcon from '@mui/icons-material/Folder';
import { LoadingButton } from "@mui/lab";
import { Avatar, Box, Button, List, ListItem, ListItemText, Modal, TextField, Typography, useMediaQuery } from "@mui/material";
import ListItemAvatar from '@mui/material/ListItemAvatar';
import MyToastShow from '@/components/Layout/MyToast';
import dayjs from 'dayjs';
import { useState } from "react";
import { useAgruparCarritosMutation } from "../../redux/api/informeApi";
import { ICarrito } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";

type ModalAgruparCarritosProps = {
    open: boolean;
    onCancel: () => void;
    carpetas: ICarrito[];
    onCarpetasAgrupadas: (carpeta: any) => void;
};



const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    boxShadow: 24,
    p: 4,
};

const ModalAgruparCarritos = ({
    carpetas,
    open,
    onCancel,
    onCarpetasAgrupadas,
}: ModalAgruparCarritosProps) => {
    const darkMode = useAppSelector((state: any) => state.theme.darkTheme);

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
    const boxWidth = isMobile ? "100%" : "40rem";

    const [agruparCarritos] = useAgruparCarritosMutation();
    const [loading, setLoading] = useState(false);
    const [nuevoNombreCarpeta, setNuevoNombreCarpeta] = useState(null);

    const handleNombreCarpeta = (event: any) => {
        setNuevoNombreCarpeta(event.target.value);
    }

    const handleAgrupar = () => {
        setLoading(true)

        const regroupDTO = {
            nombreCarpetas: nuevoNombreCarpeta,
            idCarpetas: carpetas.map((c) => c.idCarrito)
        }

        agruparCarritos(regroupDTO)
            .unwrap()
            .then((response: any) => {
                MyToastShow({
                    message: "Las carpetas se agruparon correctamente",
                    type: "success",
                });
                onCarpetasAgrupadas(response.data)
            })
            .catch((error) => {
                MyToastShow({
                    message: "Hubo un error al agrupar las carpetas",
                    type: "error",
                });
            })
            .finally(() => {
                setLoading(false)
                onCancel()
            })
    }


    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`agrupar-carpetas`}
            sx={{
                width: "100%",
            }}
        >
            <Box
                sx={(theme) => ({
                    ...style,
                    width: boxWidth,
                    overflow: "auto",
                    maxHeight: "100%",
                    bgcolor: darkMode ? "#232323" : "#fff",
                })}
                aria-label={`agrupar-container-carpetas`}
            >
                {carpetas.length > 0 ? (
                    <>
                        <Typography variant="h5" sx={{ mb: 2 }}>
                            ¿Está seguro que desea agrupar las carpetas seleccionadas?
                            Todos los archivos vinculados con el carrito serán eliminados, aunque
                            se conservaran todos los archivos y estados de los informes
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 2 }}>
                            Opcionalmente, puede elegir un nombre para el nuevo carrito
                        </Typography>

                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="Nuevo nombre carpeta"
                                rows={1}
                                sx={{ mt: '1rem' }}
                                type='text'
                                inputProps={{ min: 0 }}
                                value={nuevoNombreCarpeta}
                                onChange={handleNombreCarpeta}
                            />
                        </Box>

                        {
                            carpetas.map((carpeta) => (
                                <List key={`carrito-list-map-${carpeta.idCarrito}`}>
                                    <ListItem
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <FolderIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            //@ts-ignore
                                            primary={dayjs(carpeta.fecha).format("DD/MM/YYYY")}
                                            secondary={carpeta.idCarrito}
                                        />
                                    </ListItem>
                                </List>
                            ))
                        }
                    </>

                ) : <>No hay carpetas para agrupar</>}



                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        color="error"
                        onClick={() => handleAgrupar()}
                    >

                        Agrupar
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1 }}
                        onClick={() => onCancel()}
                    >

                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal >
    );
};

export default ModalAgruparCarritos;
